<!--人才招聘-->
<template>
  <el-row class="hei100 flex-column">
    <div id="topbar" class=" bgc-wt boxshadow">
      <el-row>
        <el-col :span="9">
          <img class="fl" src="../../assets/images/logo1.png" style="height:60px;">
        </el-col>
        <el-col :span="15">
          <el-row class="menu2" type="flex">
            <div class="text-right flexson " @click="openUrl(1)">
              <a href="#part1"><span>首页</span></a>
            </div>
            <div class="text-right flexson" @click="openUrl(2)">
              <a href="#part2"><span>软件业务</span></a>
            </div>
            <div class="text-right flexson" @click="openUrl(3)">
              <a href="#part3"><span>企业简介</span></a>
            </div>
            <div class="text-right flexson" @click="openUrl(4)">
              <a href="#part4"><span>企业优势</span></a>
            </div>
            <div class="text-right flexson onclick" @click="openUrl(5)">
              <a href="#part5"><span>新闻资讯</span></a>
            </div>
            <div class="text-right flexson" @click="dialogVisible = true">
              <a href="#part6"><span>联系我们</span></a>
            </div>
            <div class="text-right flexson " @click="openUrlJoin()">
              <span>人才招聘</span>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!--  -->
    <el-row class=" ">
      <div class="" style="padding-top:140px; padding-bottom:20px;min-height:800px;">
        <el-row class="auto hei30" style="width:1400px;">
          <span class="fc-blue ft-size16 text-underline" @click="returnP()">返回新闻列表</span>
        </el-row>
        <el-row class="fixedRt nextbgc algincenter pointer" v-if="idx<3" @click.native="nextNews()">
          <div>
            <span class="fc-wt ft-size16">下一篇</span>
            &ensp;
            <span class="inline-block posbtn">
              <i class="icon-right"></i>
            </span>
          </div>
        </el-row>
        <el-row class="fixedLf nextbgc algincenter pointer" v-if="idx>0" @click.native="prevNews()">
          <div>
            <span class="fc-wt ft-size16">上一篇</span>
            &ensp;
            <span class="inline-block posbtn">
              <i class="icon-left"></i>
            </span>
          </div>
        </el-row>
        <img v-if="idx==0" class="block wid100" src="../../assets/news/cont1.jpg" alt="">
        <img v-if="idx==2" class="block wid100" src="../../assets/news/cont21.jpg" alt="">
        <img v-if="idx==2" class="block wid100" src="../../assets/news/cont22.jpg" alt="">
        <img v-if="idx==2" class="block wid100" src="../../assets/news/cont23.jpg" alt="">
        <img v-if="idx==1" class="block wid100" src="../../assets/news/cont31.jpg" alt="">
        <img v-if="idx==1" class="block wid100" src="../../assets/news/cont32.jpg" alt="">
        <img v-if="idx==1" class="block wid100" src="../../assets/news/cont33.jpg" alt="">
        <img v-if="idx==1" class="block wid100" src="../../assets/news/cont34.jpg" alt="">
        <img v-if="idx==1" class="block wid100" src="../../assets/news/cont35.jpg" alt="">
        <img v-if="idx==1" class="block wid100" src="../../assets/news/cont36.jpg" alt="">
        <img v-if="idx==1" class="block wid100" src="../../assets/news/cont37.jpg" alt="">
        <img v-if="idx==1" class="block wid100" src="../../assets/news/cont38.jpg" alt="">
        <img v-if="idx==3" class="block wid100" src="../../assets/news/cont41.jpg" alt="">
        <img v-if="idx==3" class="block wid100" src="../../assets/news/cont42.jpg" alt="">
        <img v-if="idx==3" class="block wid100" src="../../assets/news/cont43.jpg" alt="">
        <!-- <img v-if="idx==4" class="block wid100" src="../../assets/news/cont5.jpg" alt=""> -->

      </div>
    </el-row>
    <footerbar></footerbar>
    <el-dialog title="" :visible.sync="dialogVisible" class="newdialog" width="790px" append-to-body>
      <div>
        <el-row style="padding-left:40px;padding-bottom:30px;">
          <img class="fl" src="@/assets/images/logo1.png" style="height:40px;">
        </el-row>
        <el-row>
          <el-col :span="17" style="padding-left:40px;">
            <el-row class="hei40">
              <span class="fc-2 ft-size16">地&emsp;&emsp;址:</span>
              <span class="fc-2 ft-size16">北京市昌平区北清路1号院8号楼14层</span>
            </el-row>
            <el-row class="hei40">
              <span class="fc-2 ft-size16">邮&emsp;&emsp;箱:</span>
              <span class="fc-2 ft-size16 ">155396138@qq.com&emsp;2627504375@qq.com</span>
            </el-row>           
            <el-row class="hei40">
              <span class="fc-2 ft-size16">商务合作:</span>
              <span class="fc-2 ft-size16 pointer">15869194531(乐)</span>
            </el-row>
            <el-row class="hei40">
              <span class="fc-2 ft-size16">网&emsp;&emsp;站:</span>
              <span class="fc-2 ft-size16 pointer">http://www.ylybj.cn</span>
            </el-row>
          </el-col>
          <el-col :span="7">
            <div style=" margin-left:40px; border-left:1px solid #ddd; height:200px;" class=" algincenter">
              <div>
                <el-row class="border">
                  <img class="width100 block" src="@/assets/icon/qrcode.png" alt="">
                </el-row>
                <el-row class="text-center hei30">
                  <span class="fc-2 ft-size16">微信公众号</span>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import footerbar from "../footerbar";
export default {
  name: "newsCont",
  components: { footerbar },
  data() {
    return {
      total: 30,
      pageindex: 1,
      idx: 0,
      color: "#3670ff",
      dialogVisible : false
    };
  },
  mounted() {
    this.idx = this.$route.query.index;
    window.addEventListener('scroll',this.handleScroll,true);
    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    scrollTop=0;
  },
  methods: {
    nextNews(){
      this.idx++;
    },
    prevNews(){
      this.idx--;
    },
    openUrl(n) {
      this.$router.push({ path: "/index" });
    },
    openUrlJoin() {
      this.$router.push({ path: "/joinUs" });
    },
    returnP() {
      window.history.back();
    }
  },
  destroyed() {},
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/basicData/newsCont.vue